import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';

const UniqueMarker = () => {
    return (
        <div className="ck10-media">
            <FullWrapper isMargin={false}>
                <div className="ck10-mediaInner">
                    <div className="ck10-mediaLeft">
                        <div className="ck10-mediaTitle">Медийные кампании</div>
                        <div className="ck10-mediaParagraf">
                            СК10&nbsp;&mdash; один из&nbsp;лидеров строительного рынка, поэтому
                            репутация застройщика имеет большое значение при выборе недвижимости.
                            Для усиления имиджевого эффекта запускали медийные кампании. Тестировали
                            премиальные форматы баннеров, размещение на&nbsp;тематической площадке
                            Яндекс.Недвижимость, разные форматы в&nbsp;Яндекс.Навигатор (баннеры при
                            построении маршрута, билборды по&nbsp;маршруту следования, рекомендации
                            по&nbsp;перестроению маршрута).
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <div className="ck10-mediaWrapper">
                <div className="ck10-mediaBlock">
                    <div className="ck10-mediaItem">
                        <img src="/images/pic/ck10/media.png" alt="img" className="ck10-mediaImg" />
                    </div>
                </div>
            </div>
            <FullWrapper isMargin={false}>
                <div className="ck10-mediaInner">
                    <div className="ck10-mediaLeft">
                        <div className="ck10-mediaParagraf">
                            В&nbsp;итоге запустили 28&nbsp;медийных кампаний по&nbsp;сегментам,
                            предоставленным Яндексом, по&nbsp;интересам целевой аудитории
                            и&nbsp;с&nbsp;таргетингом на&nbsp;похожую аудиторию по&nbsp;клиентским
                            базам застройщика.
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default UniqueMarker;
